/* ══════════════════════════════════════════════════════════════════════
   ALUENA — motor de front-end do protótipo (compartilhado home + produto)
   Sacola, favoritos, busca, lightbox e wiring de todos os botões.
   Estado persistido em localStorage (funciona entre as páginas).
   Injetado nas páginas pelo build.py (marcador APP_JS).
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* trava anti-duplicação: se o script for incluído 2× na mesma página,
     roda o motor uma única vez (evita drawers/sacolas duplicados). */
  if (window.__ALUENA_APP__) return;
  window.__ALUENA_APP__ = true;

  /* ---------- utilidades ---------- */
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var BRL = function (n) { return 'R$ ' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ','); };
  var parseBRL = function (s) {
    if (!s) return 0;
    var m = String(s).replace(/[^\d.,]/g, '');
    // remove separador de milhar, usa vírgula como decimal
    m = m.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    return parseFloat(m) || 0;
  };
  var slug = function (s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  };
  var esc = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  var FRETE_GRATIS = 199;
  // % de desconto no Pix: vem do metafield da loja aluena.pix_desconto (0 = sem promessa de Pix)
  var PIX_PCT = parseFloat(document.body && document.body.getAttribute('data-pix')) || 0;
  var PIX_OFF = PIX_PCT / 100;
  var PARCELAS = 3;

  /* rodando na loja Shopify de verdade (vs. protótipo estático) */
  var SHOPIFY = typeof window.Shopify === 'object' && window.Shopify !== null;

  /* ---------- armazenamento (com fallback em memória) ---------- */
  var mem = {};
  var store = {
    get: function (k, f) {
      try { var v = localStorage.getItem(k); return v == null ? f : JSON.parse(v); }
      catch (e) { return (k in mem) ? mem[k] : f; }
    },
    set: function (k, v) {
      try { localStorage.setItem(k, JSON.stringify(v)); }
      catch (e) { mem[k] = v; }
    }
  };

  var cart = SHOPIFY ? [] : normalizaCart(store.get('aluena_cart', []));
  /* desconto automático (ex.: "Complete o look") que a Shopify já aplicou no carrinho, em R$ */
  var cartDesconto = 0;
  var wish = normalizaWish(store.get('aluena_wish', {})); // { id: {id,nome,acab,preco,img} }

  /* ---------- sacola real (Shopify AJAX Cart API) ---------- */
  function shopifyCartParaEstado(sc) {
    return (sc.items || []).map(function (i) {
      var titulo = i.product_title || i.title || 'Produto';
      /* "Padrão"/"Default Title" é a variante única que o Shopify cria sozinho —
         não é informação, é ruído embaixo do nome */
      var vt = (i.variant_title || '').trim();
      var acab = (vt && !/^(default title|padr[ãa]o)$/i.test(vt)) ? vt : '';
      return {
        id: String(i.key), variantId: i.variant_id, nome: titulo, acab: acab,
        preco: (i.final_price != null ? i.final_price : i.price) / 100,
        precoOrig: (i.original_price != null ? i.original_price : i.price) / 100,
        img: i.image || '', qty: i.quantity, url: i.url || ''
      };
    });
  }
  function shopifyFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || 'Erro na sacola'); e.data = data; throw e; }
        return data;
      });
    });
  }
  function refreshCartShopify() {
    return shopifyFetch('/cart.js').then(function (sc) {
      cart = shopifyCartParaEstado(sc);
      cartDesconto = (sc.total_discount || 0) / 100;
      renderCart(); updateBadges(); return sc;
    });
  }
  /* ── Rede de segurança do "Adicionar ao carrinho" nos pixels (Meta e Google) ──
     Os apps Facebook & Instagram e Google & YouTube recebem o evento
     product_added_to_cart do Web Pixels Manager da Shopify, que o detecta
     espiando o /cart/add.js. Na auditoria de 08/10/2026 esse evento se perdeu de
     forma intermitente: a Shopify via o add (o Analytics dela registrava), mas o
     evento não chegava a nenhum pixel — nem ao de depuração da própria Shopify.
     Aqui: se em 4s o pixel do Google (que roda na página e escreve no dataLayer)
     não registrou o add_to_cart, o tema manda o evento direto ao Google e à Meta,
     no mesmo formato dos apps. Se o evento oficial chegou, não faz nada — não
     duplica. Se o pixel do Google não for observável nesta página, também não
     faz nada (sem como saber, melhor não arriscar contar duas vezes). */
  function marcaRastreio() {
    var dl = window.dataLayer;
    if (!Array.isArray(dl)) return null;
    var observavel = dl.some(function (x) { return x && x[0] === 'event' && x[2] && x[2].shopify_event_name === 'page_viewed'; });
    return observavel ? dl.length : null;
  }
  function vigiaRastreioAdd(marca, resp, pedido) {
    if (marca === null || !resp || !resp.items || !resp.items.length) return;
    setTimeout(function () {
      try {
        var dl = window.dataLayer;
        var chegou = dl.slice(marca).some(function (x) { return x && x[0] === 'event' && x[1] === 'add_to_cart'; });
        if (!chegou) enviaAddManual(resp.items, pedido || []);
      } catch (e) {}
    }, 4000);
  }
  function enviaAddManual(linhas, pedido) {
    var dl = window.dataLayer || [];
    var moeda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
    /* mesmo ID de item que o app do Google usa (shopify_<país>_<produto>_<variante>) */
    var prefixo = 'shopify_ZZ_';
    dl.some(function (x) {
      var it = x && x[2] && x[2].items && x[2].items[0];
      var m = it && typeof it.id === 'string' && it.id.match(/^(shopify_[A-Z]{2}_)/);
      if (m) { prefixo = m[1]; return true; }
      return false;
    });
    var ga = null;
    dl.some(function (x) { if (x && x[0] === 'config' && /^G-/.test(x[1])) { ga = x[1]; return true; } return false; });
    var pixel = null;
    try { pixel = window.fbq && fbq.getState && fbq.getState().pixels[0].id; } catch (e) {}
    linhas.forEach(function (l) {
      var qtd = 1;
      pedido.forEach(function (p) { if (String(p.id) === String(l.variant_id || l.id)) qtd = Number(p.quantity) || 1; });
      var preco = (l.price || 0) / 100;
      var variante = (l.variant_title && !/^(default title|padr[ãa]o)$/i.test(l.variant_title)) ? l.variant_title : '';
      var nome = l.product_title || l.title || '';
      if (ga && typeof window.gtag === 'function') {
        gtag('event', 'add_to_cart', {
          send_to: ga, currency: moeda, value: Math.round(preco * qtd * 100) / 100, aluena_fallback: 1,
          items: [{ id: prefixo + l.product_id + '_' + l.variant_id, name: nome, brand: l.vendor || 'ALUENA',
            category: l.product_type || '', price: preco, variant: variante || 'Padrão', quantity: qtd }]
        });
      }
      if (pixel && typeof window.fbq === 'function') {
        fbq('trackSingle', pixel, 'AddToCart', {
          content_ids: [l.product_id], content_type: 'product_group',
          content_name: variante ? nome + ' - ' + variante : nome, content_category: l.product_type || '',
          currency: moeda, value: preco, num_items: qtd, aluena_fallback: 1,
          contents: [{ id: l.product_id, quantity: qtd, item_price: preco }]
        }, { eventID: 'aluena-atc-' + l.variant_id + '-' + Date.now() });
      }
    });
  }

  function addCartShopify(prod, qty) {
    if (!prod || !prod.variantId) { toast('Não foi possível identificar a peça.'); return Promise.resolve(); }
    var pedido = [{ id: prod.variantId, quantity: qty }];
    var marca = marcaRastreio();
    return shopifyFetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: pedido }) })
      .then(function (r) { vigiaRastreioAdd(marca, r, pedido); })
      .then(refreshCartShopify)
      .catch(function (e) { toast(e.message || 'Não foi possível adicionar à sacola.'); throw e; });
  }
  /* vários itens numa chamada só: dois /cart/add.js em paralelo disputam o
     mesmo carrinho e o segundo sobrescreve o primeiro (testado — só o bump
     entrava). Uma requisição com a lista inteira é atômica. */
  function addCartShopifyItens(itens) {
    var marca = marcaRastreio();
    return shopifyFetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: itens }) })
      .then(function (r) { vigiaRastreioAdd(marca, r, itens); })
      .then(refreshCartShopify)
      .catch(function (e) { toast(e.message || 'Não foi possível adicionar à sacola.'); throw e; });
  }
  function setQtyShopify(lineKey, qty) {
    return shopifyFetch('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: lineKey, quantity: qty }) })
      .then(refreshCartShopify)
      .catch(function (e) { toast(e.message || 'Não foi possível atualizar a sacola.'); throw e; });
  }

  function normalizaCart(c) {
    if (!Array.isArray(c)) return [];
    return c.filter(function (i) { return i && i.id; }).map(function (i) {
      return {
        id: String(i.id), nome: String(i.nome || 'Produto'), acab: String(i.acab || ''),
        preco: Number(i.preco) || 0, img: String(i.img || ''),
        qty: Math.max(1, Math.min(10, parseInt(i.qty, 10) || 1))
      };
    });
  }
  function normalizaWish(w) {
    if (!w || typeof w !== 'object' || Array.isArray(w)) return {};
    var out = {};
    Object.keys(w).forEach(function (k) {
      var i = w[k];
      if (i && typeof i === 'object' && i.id) {
        out[String(i.id)] = {
          id: String(i.id), variantId: String(i.variantId || ''), nome: String(i.nome || 'Produto'), acab: String(i.acab || ''),
          preco: Number(i.preco) || 0, img: String(i.img || '')
        };
      }
    });
    return out;
  }
  function salvar() { store.set('aluena_cart', cart); store.set('aluena_wish', wish); }

  /* ---------- extração de produto a partir do DOM ---------- */
  function fromCard(card) {
    if (!card) return null;
    var nome = txt('.card-nome', card) || 'Produto';
    var acab = txt('.card-acab', card) || '';
    var preco = parseBRL(txt('.card-preco', card));
    var imgEl = $('.card-foto img', card);
    var img = imgEl ? imgEl.getAttribute('src') : '';
    var novo = !!$('.badge-novo', card);
    var variantId = card.getAttribute('data-variant-id') || '';
    return { id: variantId ? 'v' + variantId : slug(nome + '-' + acab), variantId: variantId, nome: nome, acab: acab, preco: preco, img: img, novo: novo };
  }
  function fromPDP() {
    var c = $('.compra'); if (!c) return null;
    var nome = txt('h1', c) || 'Produto';
    var acab = c.getAttribute('data-acab') || 'Banho de ouro 18k';
    var preco = parseBRL(txt('.preco-por', c));
    /* a miniatura da sacola é sempre a foto principal, não a mídia em exibição */
    var imgEl = $('#palco img.palco-midia');
    var img = imgEl ? imgEl.getAttribute('src') : '';
    var variantId = c.getAttribute('data-variant-id') || '';
    return { id: variantId ? 'v' + variantId : slug(nome + '-' + acab), variantId: variantId, nome: nome, acab: acab, preco: preco, img: img };
  }
  function fromContainer(sel) {
    var c = $(sel); if (!c) return null;
    var nome = txt('h2', c) || txt('h3', c) || 'Produto';
    var acab = c.getAttribute('data-acab') || '';
    var preco = parseBRL(txt('.destaque-preco .valor', c) || txt('.card-preco', c));
    var imgEl = $('img', c);
    var img = imgEl ? imgEl.getAttribute('src') : '';
    var variantId = c.getAttribute('data-variant-id') || '';
    return { id: variantId ? 'v' + variantId : slug(nome + '-' + acab), variantId: variantId, nome: nome, acab: acab, preco: preco, img: img };
  }
  function txt(sel, c) { var e = $(sel, c); return e ? e.textContent.trim() : ''; }

  /* ---------- sacola ---------- */
  function addCart(prod, qty) {
    if (!prod || !prod.id) return Promise.resolve();
    qty = Math.max(1, parseInt(qty, 10) || 1);
    if (SHOPIFY) return addCartShopify(prod, qty);
    var ex = null;
    for (var i = 0; i < cart.length; i++) if (cart[i].id === prod.id) { ex = cart[i]; break; }
    if (ex) ex.qty = Math.min(10, ex.qty + qty);
    else cart.push({ id: prod.id, nome: prod.nome, acab: prod.acab, preco: prod.preco, img: prod.img, qty: Math.min(10, qty) });
    salvar(); renderCart(); updateBadges();
    return Promise.resolve();
  }
  function setQty(id, qty) {
    qty = parseInt(qty, 10) || 0;
    if (SHOPIFY) { setQtyShopify(id, Math.max(0, qty)); return; }
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].id === id) {
        if (qty <= 0) { cart.splice(i, 1); }
        else cart[i].qty = Math.min(10, qty);
        break;
      }
    }
    salvar(); renderCart(); updateBadges();
  }
  function removeCart(id) {
    if (SHOPIFY) { setQtyShopify(id, 0); return; }
    cart = cart.filter(function (i) { return i.id !== id; });
    salvar(); renderCart(); updateBadges();
  }
  function cartCount() { return cart.reduce(function (s, i) { return s + i.qty; }, 0); }
  function cartSubtotal() { return cart.reduce(function (s, i) { return s + i.preco * i.qty; }, 0); }

  /* ---------- favoritos ---------- */
  function toggleWish(prod) {
    if (!prod || !prod.id) return false;
    var agora;
    if (wish[prod.id]) { delete wish[prod.id]; agora = false; }
    else { wish[prod.id] = { id: prod.id, variantId: prod.variantId || '', nome: prod.nome, acab: prod.acab, preco: prod.preco, img: prod.img }; agora = true; }
    salvar(); renderWish(); updateBadges(); syncHearts();
    return agora;
  }
  function wishCount() { return Object.keys(wish).length; }
  function isWished(id) { return !!wish[id]; }

  /* ══════════════════════════════════════════════════════════════════
     CSS dos componentes (injetado — usa os tokens já definidos na página)
     ══════════════════════════════════════════════════════════════════ */
  var CSS = ''
    + '.ov-backdrop{position:fixed;inset:0;background:rgba(30,38,28,.42);opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease;z-index:80}'
    + '.ov-backdrop.ativo{opacity:1;visibility:visible}'
    + 'body.sem-scroll{overflow:hidden}'
    + '.drawer{position:fixed;top:0;right:0;bottom:0;width:min(420px,92vw);background:#fff;z-index:90;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .3s cubic-bezier(.4,0,.2,1)}'
    /* a sombra só existe com a gaveta aberta: fechada, ela fica encostada na borda direita e a
       sombra vazava pra dentro da tela como uma faixa cinza em todas as páginas */
    + '.drawer.aberto{transform:none;box-shadow:-8px 0 40px rgba(30,38,28,.16)}'
    + '.drawer-head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px;border-bottom:1px solid var(--linha)}'
    + '.drawer-head h2{font-family:var(--display);font-weight:var(--peso-titulo);letter-spacing:var(--ls-titulo);font-size:1.4rem;color:var(--tinta)}'
    + '.drawer-fechar{width:44px;height:44px;border-radius:50%;display:grid;place-items:center;color:var(--tinta);font-size:22px;line-height:1;transition:background .2s ease}'
    + '.drawer-fechar:hover{background:var(--areia)}'
    + '.frete-barra{padding:14px 22px;border-bottom:1px solid var(--linha);background:var(--areia)}'
    + '.frete-barra .msg{font-size:13px;color:var(--tinta);margin-bottom:8px}'
    + '.frete-barra .msg b{color:var(--verde-cta);font-weight:600}'
    + '.frete-barra .track{height:6px;background:#E4E7E3;border-radius:0;overflow:hidden}'
    + '.frete-barra .fill{height:100%;background:var(--verde-cta);border-radius:0;transition:width .35s ease}'
    + '.drawer-itens{flex:1;overflow-y:auto;padding:8px 22px}'
    + '.drawer-vazio{text-align:center;color:var(--cinza);padding:56px 12px;font-size:15px}'
    + '.drawer-vazio svg{width:44px;height:44px;stroke:var(--salvia);fill:none;stroke-width:1.3;margin:0 auto 14px}'
    + '.linha-item{display:flex;gap:14px;padding:18px 0;border-bottom:1px solid var(--linha)}'
    + '.linha-item .li-foto{width:74px;height:74px;flex-shrink:0;border-radius:0;overflow:hidden;background:var(--areia)}'
    + '.linha-item .li-foto img{width:100%;height:100%;object-fit:cover;mix-blend-mode:multiply}'
    + '.linha-item .li-corpo{flex:1;min-width:0}'
    + '.linha-item .li-nome{font-size:14.5px;font-weight:500;color:var(--tinta);line-height:1.35}'
    + '.linha-item .li-acab{font-size:12.5px;color:var(--cinza);margin-top:1px}'
    + '.linha-item .li-preco{font-size:14px;color:var(--tinta);font-weight:500;margin-top:6px}'
    + '.linha-item .li-baixo{display:flex;align-items:center;justify-content:space-between;margin-top:10px}'
    + '.li-stepper{display:inline-flex;align-items:center;border:1px solid var(--linha);border-radius:0}'
    + '.li-stepper button{width:30px;height:30px;font-size:15px;color:var(--musgo);display:grid;place-items:center}'
    + '.li-stepper button:hover{background:var(--areia)}'
    + '.li-stepper span{min-width:30px;text-align:center;font-size:14px;color:var(--tinta)}'
    + '.li-remover{font-size:12.5px;color:var(--cinza);border-bottom:1px solid transparent;transition:color .2s,border-color .2s}'
    + '.li-remover:hover{color:#A35D4F;border-color:#A35D4F}'
    /* dedo: alvos de toque de 40px na sacola (eram 30px e um link de texto de ~18px) */
    + '@media(pointer:coarse){.li-stepper button{width:40px;height:40px}.li-stepper span{min-width:34px}.li-remover{padding:11px 2px}}'
    + '.drawer-foot{border-top:1px solid var(--linha);padding:18px 22px calc(18px + env(safe-area-inset-bottom))}'
    + '.foot-linha{display:flex;justify-content:space-between;align-items:baseline;font-size:14px;color:var(--cinza);margin-bottom:6px}'
    + '.foot-linha.total{font-size:16px;color:var(--tinta)}'
    + '.foot-linha.total b{font-size:22px;font-weight:700}'
    + '.foot-linha .pix-val{color:var(--verde-cta);font-weight:600}'
    + '.foot-linha.desc{color:var(--verde-cta);font-weight:600}'
    + '.foot-eco{font-size:12.5px;font-weight:600;color:var(--verde-cta);background:var(--salvia-veu);padding:8px 12px;margin:2px 0 10px;text-align:center}'
    + '.linha-item .li-de{font-weight:400;color:var(--cinza);text-decoration:line-through;margin-right:6px;font-size:13px}'
    + '.foot-parc{font-size:12.5px;color:var(--cinza);text-align:right;margin:2px 0 14px}'
    + '.btn-checkout{display:flex;width:100%;align-items:center;justify-content:center;gap:8px;min-height:56px;padding:16px;background:var(--verde-cta);color:#fff;border-radius:0;font-size:15px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;transition:background .2s ease}'
    + '.btn-checkout:hover{background:var(--verde-cta-hover)}'
    /* aviso do Pix: só aparece quando o botão do app Scala está na gaveta (ele entra antes do .btn-checkout) */
    + '.foot-nota-pix{display:none;font-size:12px;line-height:1.5;color:var(--cinza);text-align:center;margin:10px 0 0}'
    + '.drawer-foot scala-cart-button ~ .foot-nota-pix{display:block}'
    + '.foot-selos{display:flex;justify-content:center;gap:16px;margin-top:14px;flex-wrap:wrap}'
    + '.foot-selos span{font-size:12.5px;color:var(--cinza);display:flex;align-items:center;gap:5px}'
    + '.foot-selos svg{width:13px;height:13px;stroke:var(--verde-cta);fill:none;stroke-width:1.7}'
    /* wishlist mover */
    + '.li-mover{font-size:12.5px;color:var(--verde-cta);font-weight:500;border-bottom:1px solid transparent;transition:border-color .2s}'
    + '.li-mover:hover{border-color:var(--verde-cta)}'
    /* busca */
    + '.busca-ov{position:fixed;top:0;left:0;right:0;background:#fff;z-index:90;transform:translateY(-100%);transition:transform .3s cubic-bezier(.4,0,.2,1);box-shadow:0 12px 40px rgba(30,38,28,.14);max-height:88vh;display:flex;flex-direction:column}'
    + '.busca-ov.aberto{transform:none}'
    + '.busca-top{max-width:var(--container);margin:0 auto;width:100%;padding:20px 24px;display:flex;align-items:center;gap:14px}'
    + '.busca-top svg.lupa{width:22px;height:22px;stroke:var(--musgo);fill:none;stroke-width:1.6;flex-shrink:0}'
    + '.busca-top input{flex:1;border:none;font-family:var(--sans);font-weight:600;font-size:clamp(1.3rem,3vw,1.8rem);color:var(--tinta);background:transparent;min-width:0}'
    + '.busca-top input:focus{outline:none}'
    + '.busca-top input::placeholder{color:var(--cinza)}'
    + '.busca-fechar{width:44px;height:44px;border-radius:50%;display:grid;place-items:center;color:var(--tinta);font-size:24px;transition:background .2s}'
    + '.busca-fechar:hover{background:var(--areia)}'
    + '.busca-res{max-width:var(--container);margin:0 auto;width:100%;padding:0 24px 26px;overflow-y:auto}'
    + '.busca-res .dica{font-size:13px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--cinza);padding:8px 0 14px;border-top:1px solid var(--linha)}'
    + '.busca-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:18px}'
    + '.busca-item{cursor:pointer;text-align:left}'
    + '.busca-item .bi-foto{aspect-ratio:1/1;border-radius:0;overflow:hidden;background:var(--areia);margin-bottom:9px}'
    + '.busca-item .bi-foto img{width:100%;height:100%;object-fit:cover;mix-blend-mode:multiply;transition:transform .3s}'
    + '.busca-item:hover .bi-foto img{transform:scale(1.05)}'
    + '.busca-item .bi-nome{font-size:14px;color:var(--tinta);font-weight:500;line-height:1.35}'
    + '.busca-item .bi-preco{font-size:13.5px;color:var(--cinza);margin-top:2px}'
    + '.busca-nada{color:var(--cinza);font-size:15px;padding:10px 0 20px}'
    /* lightbox */
    + '.lightbox{position:fixed;inset:0;z-index:100;background:rgba(24,30,22,.9);display:none;align-items:center;justify-content:center;padding:32px;opacity:0;transition:opacity .25s ease}'
    + '.lightbox.aberto{display:flex;opacity:1}'
    + '.lightbox img{max-width:92vw;max-height:88vh;border-radius:0;box-shadow:0 20px 60px rgba(0,0,0,.4)}'
    + '.lightbox .lb-cap{position:absolute;bottom:22px;left:0;right:0;text-align:center;color:rgba(255,255,255,.9);font-size:14px}'
    + '.lightbox .lb-fechar{position:absolute;top:20px;right:24px;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;font-size:26px;display:grid;place-items:center;transition:background .2s}'
    + '.lightbox .lb-fechar:hover{background:rgba(255,255,255,.28)}'
    /* badge de favoritos + coração ativo */
    + '.fav-badge{position:absolute;top:2px;right:0;min-width:16px;height:16px;border-radius:8px;background:var(--verde-cta);color:#fff;font-size:10px;font-weight:500;display:grid;place-items:center;padding:0 4px}'
    /* base do coração de card (garante estilo também nos cards da PDP, onde não há CSS próprio) */
    + '.card-foto{position:relative}'
    /* 40x40 (44 no toque) para o dedo acertar sem esforço — o círculo branco
       visível continua discreto porque o fundo só cobre o centro */
    + '.card-fav{position:absolute;top:6px;right:6px;z-index:4;width:40px;height:40px;display:grid;place-items:center;border-radius:50%;color:var(--cinza);background:transparent;border:none;cursor:pointer;opacity:0;transition:opacity .2s ease,color .2s ease,transform .15s ease}'
    + '.card-fav::before{content:"";position:absolute;width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,.88);box-shadow:0 1px 5px rgba(42,51,38,.1)}'
    + '.card:hover .card-fav,.card-fav:focus-visible{opacity:1}'
    + '.card-fav:hover{color:var(--musgo)}'
    + '.card-fav:active{transform:scale(.9)}'
    + '.card-fav svg{position:relative;width:17px;height:17px;stroke:currentColor;fill:none;stroke-width:1.6}'
    + '@media(hover:none){.card-fav{opacity:1;width:44px;height:44px}}'
    + '.card-fav.ativo{opacity:1;color:var(--verde-cta)}'
    + '.card-fav.ativo svg{fill:var(--verde-cta);stroke:var(--verde-cta)}'
    + '.pdp-fav{display:inline-flex;align-items:center;align-self:flex-start;gap:8px;margin-top:12px;padding:11px 14px 11px 0;font-size:13px;color:var(--cinza);letter-spacing:.02em}'
    + '.pdp-fav svg{width:19px;height:19px;stroke:var(--musgo);fill:none;stroke-width:1.6;transition:fill .2s}'
    + '.pdp-fav.ativo{color:var(--verde-cta)}'
    + '.pdp-fav.ativo svg{fill:var(--verde-cta);stroke:var(--verde-cta)}'
    /* toast */
    + '.toast{position:fixed;bottom:26px;left:50%;transform:translate(-50%,120px);background:var(--musgo);color:#fff;padding:13px 26px;border-radius:0;font-size:13.5px;letter-spacing:.03em;box-shadow:0 10px 30px rgba(42,51,38,.25);z-index:110;max-width:90vw;text-align:center;opacity:0;visibility:hidden;transition:transform .3s ease,opacity .25s ease,visibility .25s}'
    + '.toast.mostrar{transform:translate(-50%,0);opacity:1;visibility:visible}'
    + '@media(max-width:960px){.toast{bottom:88px}}'
    /* popup de boas-vindas (cupom de primeira compra) */
    + '.popup-bv{position:fixed;top:50%;left:50%;transform:translate(-50%,-48%) scale(.97);width:min(400px,88vw);background:#fff;z-index:95;border-radius:0;box-shadow:0 26px 70px rgba(30,38,28,.32);padding:40px 28px 30px;text-align:center;opacity:0;visibility:hidden;transition:opacity .3s ease,visibility .3s ease,transform .3s cubic-bezier(.4,0,.2,1)}'
    + '.popup-bv.aberto{opacity:1;visibility:visible;transform:translate(-50%,-50%) scale(1)}'
    + '.popup-bv-fechar{position:absolute;top:8px;right:8px;width:40px;height:40px;border-radius:50%;display:grid;place-items:center;color:var(--cinza);font-size:22px;line-height:1;transition:background .2s ease,color .2s ease}'
    + '.popup-bv-fechar:hover{background:var(--areia);color:var(--tinta)}'
    + '.popup-bv h2{font-family:var(--display);font-weight:var(--peso-titulo);letter-spacing:var(--ls-titulo);font-size:clamp(1.5rem,4.2vw,1.85rem);color:var(--tinta);line-height:1.22;margin-top:8px}'
    + '.popup-bv h2 .realce{color:var(--verde-cta)}'
    + '.popup-bv p{font-size:15px;color:var(--cinza);line-height:1.6;margin:12px 0 22px}'
    + '.popup-bv-campos{display:flex;flex-direction:column;gap:10px}'
    + '.popup-bv-campos input{font-family:var(--sans);font-size:16px;padding:13px 14px;border:1px solid var(--linha);border-radius:0;color:var(--tinta);width:100%}'
    + '.popup-bv-campos input:focus{outline:none;border-color:var(--musgo)}'
    + '.popup-bv-depois{display:block;margin:14px auto 0;font-size:12.5px;color:var(--cinza);border-bottom:1px solid transparent;padding-bottom:1px}'
    + '@media(hover:hover){.popup-bv-depois:hover{color:var(--tinta);border-color:var(--linha)}}'
    + '.popup-bv-legal{font-size:12px;color:var(--cinza);line-height:1.5;margin:12px 0 0}.popup-bv-legal a{color:inherit;text-decoration:underline}'
    + '.popup-bv-msg{font-size:15px;color:var(--musgo);font-weight:500;line-height:1.6}';

  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 20.5C7 16.5 3.5 13.2 3.5 9.4 3.5 6.7 5.6 5 8 5c1.6 0 3.1.8 4 2.1C12.9 5.8 14.4 5 16 5c2.4 0 4.5 1.7 4.5 4.4 0 3.8-3.5 7.1-8.5 11.1z"/></svg>';

  /* ══════════════════════════════════════════════════════════════════
     Construção do DOM (backdrop, drawers, busca, lightbox, toast)
     ══════════════════════════════════════════════════════════════════ */
  var backdrop, drawerSacola, drawerWish, buscaOv, lightbox, popupBV, toastEl, painelAtivo = null, ultimoFoco = null;

  function montarUI() {
    var st = document.createElement('style'); st.id = 'aluena-app-css'; st.textContent = CSS;
    document.head.appendChild(st);

    backdrop = el('div', 'ov-backdrop'); backdrop.setAttribute('data-fechar', '');
    document.body.appendChild(backdrop);

    /* sacola */
    drawerSacola = el('aside', 'drawer'); drawerSacola.id = 'drawerSacola';
    drawerSacola.setAttribute('role', 'dialog'); drawerSacola.setAttribute('aria-modal', 'true');
    drawerSacola.setAttribute('aria-label', 'Sua sacola'); drawerSacola.setAttribute('aria-hidden', 'true');
    drawerSacola.innerHTML =
      '<div class="drawer-head"><h2>Sua sacola</h2><button class="drawer-fechar" data-fechar aria-label="Fechar sacola">&times;</button></div>'
      + '<div class="frete-barra" id="freteBarra"></div>'
      + '<div class="drawer-itens" id="cartItens"></div>'
      + '<div class="drawer-foot" id="cartFoot"></div>';
    document.body.appendChild(drawerSacola);

    /* favoritos */
    drawerWish = el('aside', 'drawer'); drawerWish.id = 'drawerWish';
    drawerWish.setAttribute('role', 'dialog'); drawerWish.setAttribute('aria-modal', 'true');
    drawerWish.setAttribute('aria-label', 'Seus favoritos'); drawerWish.setAttribute('aria-hidden', 'true');
    drawerWish.innerHTML =
      '<div class="drawer-head"><h2>Favoritos</h2><button class="drawer-fechar" data-fechar aria-label="Fechar favoritos">&times;</button></div>'
      + '<div class="drawer-itens" id="wishItens"></div>';
    document.body.appendChild(drawerWish);

    /* busca */
    buscaOv = el('div', 'busca-ov'); buscaOv.id = 'buscaOv';
    buscaOv.setAttribute('role', 'dialog'); buscaOv.setAttribute('aria-label', 'Buscar produtos'); buscaOv.setAttribute('aria-hidden', 'true');
    buscaOv.innerHTML =
      '<div class="busca-top">'
      + '<svg class="lupa" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>'
      + '<input id="buscaInput" type="search" placeholder="O que você procura?" aria-label="Buscar produtos" autocomplete="off">'
      + '<button class="busca-fechar" data-fechar aria-label="Fechar busca">&times;</button>'
      + '</div><div class="busca-res" id="buscaRes"></div>';
    document.body.appendChild(buscaOv);

    /* lightbox */
    lightbox = el('div', 'lightbox'); lightbox.id = 'lightbox';
    lightbox.setAttribute('role', 'dialog'); lightbox.setAttribute('aria-label', 'Imagem ampliada');
    lightbox.innerHTML = '<button class="lb-fechar" data-fechar aria-label="Fechar">&times;</button><img id="lbImg" src="" alt=""><div class="lb-cap" id="lbCap"></div>';
    document.body.appendChild(lightbox);

    /* popup de boas-vindas */
    popupBV = el('div', 'popup-bv'); popupBV.id = 'popupBV';
    popupBV.setAttribute('role', 'dialog'); popupBV.setAttribute('aria-modal', 'true');
    popupBV.setAttribute('aria-label', 'Ganhe 10% de desconto na primeira compra');
    popupBV.setAttribute('aria-hidden', 'true');
    popupBV.innerHTML =
      '<button class="popup-bv-fechar" data-fechar aria-label="Fechar">&times;</button>'
      + '<span class="eyebrow">Antes de você ir</span>'
      + '<h2>Ganhe <span class="realce">10% OFF</span> na primeira compra</h2>'
      + '<p>Cadastre-se e receba seu cupom agora, além de novidades e ofertas exclusivas.</p>'
      + '<form id="popupBVForm" action="/contact#ContactFooter" method="post" accept-charset="UTF-8">'
      + '<input type="hidden" name="form_type" value="customer">'
      + '<input type="hidden" name="utf8" value="&#10003;">'
      + '<input type="hidden" name="contact[tags]" value="newsletter,popup-saida">'
      + '<div class="popup-bv-campos">'
      + '<input type="email" name="contact[email]" placeholder="Seu melhor e-mail" required aria-label="E-mail" autocomplete="email">'
      + '<button class="btn btn-solido" type="submit">Quero meu cupom</button>'
      + '</div><p class="popup-bv-legal">Ao se cadastrar, você aceita receber nossos e-mails e pode sair quando quiser. <a href="/policies/privacy-policy">Política de privacidade</a>.</p></form>'
      + '<button class="popup-bv-depois" data-fechar>Agora não</button>';
    document.body.appendChild(popupBV);

    /* toast (reaproveita #toast se já existir) */
    toastEl = $('#toast');
    if (!toastEl) { toastEl = el('div', 'toast'); toastEl.id = 'toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    else { toastEl.className = 'toast'; }
  }
  function el(t, c) { var e = document.createElement(t); if (c) e.className = c; return e; }

  /* ══════════════════════════════════════════════════════════════════
     Renderização
     ══════════════════════════════════════════════════════════════════ */
  function renderCart() {
    var itens = $('#cartItens'), foot = $('#cartFoot'), barra = $('#freteBarra');
    if (!itens) return;
    if (!cart.length) {
      itens.innerHTML = '<div class="drawer-vazio"><svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>Sua sacola está vazia.<br>Que tal escolher uma peça para brilhar?</div>';
      foot.innerHTML = ''; barra.style.display = 'none';
      return;
    }
    barra.style.display = '';
    var sub = cartSubtotal();
    var falta = FRETE_GRATIS - sub;
    var pct = Math.max(0, Math.min(100, (sub / FRETE_GRATIS) * 100));
    barra.innerHTML =
      '<div class="msg">' + (falta > 0
        ? 'Faltam <b>' + BRL(falta) + '</b> para o <b>frete grátis</b>'
        : '🎉 Você ganhou <b>frete grátis</b>!') + '</div>'
      + '<div class="track"><div class="fill" style="width:' + pct + '%"></div></div>';

    itens.innerHTML = cart.map(function (i) {
      return '<div class="linha-item" data-id="' + esc(i.id) + '">'
        + '<div class="li-foto">' + (i.img ? '<img src="' + esc(i.img) + '" alt="">' : '') + '</div>'
        + '<div class="li-corpo">'
        + '<div class="li-nome">' + esc(i.nome) + '</div>'
        + (i.acab ? '<div class="li-acab">' + esc(i.acab) + '</div>' : '')
        + '<div class="li-preco">' + (i.precoOrig && i.precoOrig > i.preco + 0.001 ? '<s class="li-de">' + BRL(i.precoOrig) + '</s>' : '') + BRL(i.preco) + '</div>'
        + '<div class="li-baixo">'
        + '<div class="li-stepper"><button data-menos aria-label="Diminuir">&minus;</button><span>' + i.qty + '</span><button data-mais aria-label="Aumentar">+</button></div>'
        + '<button class="li-remover" data-remover>Remover</button>'
        + '</div></div></div>';
    }).join('');

    // arredonda em centavos como o Liquid do /cart, senão a gaveta e a página diferem em 1 centavo
    var pix = Math.round(sub * 100 * (1 - PIX_OFF)) / 100;
    var desc = SHOPIFY ? cartDesconto : 0;
    foot.innerHTML =
      '<div class="foot-linha"><span>Subtotal</span><span>' + BRL(sub + desc) + '</span></div>'
      + (desc > 0.004 ? '<div class="foot-linha desc"><span>Desconto do conjunto</span><span>&minus; ' + BRL(desc) + '</span></div>' : '')
      + '<div class="foot-linha total"><span>Total</span><b>' + BRL(sub) + '</b></div>'
      + (desc > 0.004 ? '<div class="foot-eco">Você economizou ' + BRL(desc) + ' com o conjunto ✓</div>' : '')
      + (PIX_PCT > 0 ? '<div class="foot-linha"><span>No Pix (' + PIX_PCT + '% OFF)</span><span class="pix-val">' + BRL(pix) + '</span></div>' : '')
      + '<div class="foot-parc">ou ' + PARCELAS + '× de ' + BRL(sub / PARCELAS) + ' sem juros</div>'
      + '<button class="btn-checkout" data-checkout>Finalizar compra</button>'
      + (PIX_PCT > 0 ? '<p class="foot-nota-pix">Os ' + PIX_PCT + '% OFF no Pix valem no botão “Pagar no Pix”.</p>' : '')
      + '<div class="foot-selos">'
      + '<span><svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="m9 12 2 2 4-4"/></svg>Compra segura</span>'
      + '<span><svg viewBox="0 0 24 24"><path d="M4 9h13l-3-3m6 9H7l3 3"/></svg>Troca em 7 dias</span>'
      + '</div>';
    /* O botão "Pagar no Pix com 5% OFF" é do app Scala, que só se instala quando
       encontra o botão de checkout. A gaveta é redesenhada pelo tema (abrir depois
       de "Adicionar à sacola" não passa por nenhum gatilho que o app reconheça), e
       sem este aviso a gaveta ficava sem o botão do Pix. O app escuta este evento
       da própria Shopify e não duplica o botão se ele já estiver lá. */
    if (SHOPIFY && PIX_PCT > 0) {
      try { document.dispatchEvent(new Event('shopify:payment_button:loaded')); } catch (e) {}
    }
  }

  function renderWish() {
    var itens = $('#wishItens'); if (!itens) return;
    var ids = Object.keys(wish);
    if (!ids.length) {
      itens.innerHTML = '<div class="drawer-vazio">' + HEART + 'Você ainda não favoritou nenhuma peça.<br>Toque no coração das que amar.</div>';
      return;
    }
    itens.innerHTML = ids.map(function (id) {
      var i = wish[id];
      return '<div class="linha-item" data-id="' + esc(i.id) + '">'
        + '<div class="li-foto">' + (i.img ? '<img src="' + esc(i.img) + '" alt="">' : '') + '</div>'
        + '<div class="li-corpo">'
        + '<div class="li-nome">' + esc(i.nome) + '</div>'
        + (i.acab ? '<div class="li-acab">' + esc(i.acab) + '</div>' : '')
        + '<div class="li-preco">' + BRL(i.preco) + '</div>'
        + '<div class="li-baixo">'
        + '<button class="li-mover" data-mover>Mover para a sacola</button>'
        + '<button class="li-remover" data-desfav>Remover</button>'
        + '</div></div></div>';
    }).join('');
  }

  function updateBadges() {
    var n = cartCount();
    var badge = $('#sacola');
    var btnSac = $('[aria-label^="Sacola"]');
    if (badge) { badge.textContent = n; badge.style.display = n ? '' : 'none'; }
    if (btnSac) btnSac.setAttribute('aria-label', 'Sacola de compras — ' + n + (n === 1 ? ' item' : ' itens'));

    var w = wishCount();
    $$('[aria-label="Favoritos"]').forEach(function (btnFav) {
      var fb = btnFav.querySelector('.fav-badge');
      if (w) {
        if (!fb) { fb = el('span', 'fav-badge'); btnFav.appendChild(fb); }
        fb.textContent = w; fb.style.display = '';
      } else if (fb) { fb.style.display = 'none'; }
    });
  }

  function syncHearts() {
    $$('.card').forEach(function (card) {
      var p = fromCard(card); if (!p) return;
      var h = $('.card-fav', card);
      if (h) {
        var on = isWished(p.id);
        h.classList.toggle('ativo', on);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
        h.setAttribute('aria-label', on ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
      }
    });
    var pf = $('#pdpFav');
    if (pf) {
      var pp = fromPDP(); var on = pp ? isWished(pp.id) : false;
      pf.classList.toggle('ativo', on);
      pf.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = pf.querySelector('span'); if (lbl) lbl.textContent = on ? 'Salvo nos favoritos' : 'Adicionar aos favoritos';
    }
  }

  /* Garante um coração em todo card que não tenha (ex.: cards da PDP) */
  function garantirCoracoes() {
    $$('.card-foto').forEach(function (foto) {
      if (!foto.querySelector('.card-fav')) {
        var b = el('button', 'card-fav');
        b.setAttribute('type', 'button');
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', 'Adicionar aos favoritos');
        b.innerHTML = HEART;
        foto.insertBefore(b, foto.firstChild);
      }
    });
  }

  /* ══════════════════════════════════════════════════════════════════
     Abrir / fechar painéis
     ══════════════════════════════════════════════════════════════════ */
  function abrir(painel) {
    fecharTudo(true);
    ultimoFoco = document.activeElement;
    backdrop.classList.add('ativo');
    painel.classList.add('aberto'); painel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sem-scroll');
    painelAtivo = painel;
    var f = painel.querySelector('input') || painel.querySelector('[data-fechar]');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function fecharTudo(silencioso) {
    if (backdrop) backdrop.classList.remove('ativo');
    [drawerSacola, drawerWish, buscaOv, popupBV].forEach(function (p) { if (p) { p.classList.remove('aberto'); p.setAttribute('aria-hidden', 'true'); } });
    if (lightbox) lightbox.classList.remove('aberto');
    document.body.classList.remove('sem-scroll');
    if (!silencioso && ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    painelAtivo = null;
  }
  function abrirSacola() { renderCart(); abrir(drawerSacola); }
  function abrirFavoritos() { renderWish(); abrir(drawerWish); }
  function abrirBusca(q) {
    abrir(buscaOv);
    var inp = $('#buscaInput'); if (inp) inp.value = q || '';
    renderBusca(q || '');
  }
  /*
    Popup de boas-vindas: dispara por intenção de saída no desktop (mouse
    sobe até sair pelo topo da janela — clientY<=0, o sinal clássico de
    "vai fechar a aba/voltar"), e por tempo ou rolagem no mobile, onde não
    existe mouseleave. Uma vez visto (fechado, "agora não" ou cadastrado),
    nunca mais aparece nesse navegador — sem isso vira spam a cada visita.
    Não dispara na sacola/checkout, onde só atrapalharia quem já está
    comprando.
  */
  function iniciarPopupBoasVindas() {
    if (!popupBV) return;
    if (/^\/(cart|checkout)/.test(location.pathname)) return;
    // no celular, na página do produto, o pop-up cobria o botão de compra (quem chega do anúncio cai aqui)
    if (/\/products\//.test(location.pathname) && window.innerWidth < 960) return;
    if (store.get('aluena_popup_visto', false)) return;

    var disparado = false;
    var timer = setTimeout(mostrar, 25000);
    function pararEscuta() {
      document.removeEventListener('mouseleave', aoSairTopo);
      window.removeEventListener('scroll', aoRolar);
      clearTimeout(timer);
    }
    function mostrar() {
      if (disparado || painelAtivo) return;
      disparado = true;
      pararEscuta();
      store.set('aluena_popup_visto', true);
      abrir(popupBV);
    }
    function aoSairTopo(e) { if (e.clientY <= 0) mostrar(); }
    function aoRolar() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      if (max > 0 && (window.scrollY || doc.scrollTop) / max > 0.5) mostrar();
    }
    document.addEventListener('mouseleave', aoSairTopo);
    window.addEventListener('scroll', aoRolar, { passive: true });

    $$('[data-fechar]', popupBV).forEach(function (b) {
      b.addEventListener('click', function () { store.set('aluena_popup_visto', true); pararEscuta(); });
    });

    /* Envio NATIVO (sem fetch): a Shopify exige captcha no cadastro de cliente e
       um fetch volta 400 "Missing CAPTCHA token" — o cliente não era criado, mas a
       tela mostrava o cupom, que depois era recusado no checkout (o BEMVINDA10 só
       vale para cliente cadastrado sem pedidos). Pelo envio normal a Shopify faz o
       captcha (invisível ou a página de desafio) e volta para esta mesma página com
       ?customer_posted=true#ContactFooter — aí mostrarCupomPopup() exibe o cupom. */
    var form = $('#popupBVForm', popupBV);
    if (form) {
      form.addEventListener('submit', function () {
        store.set('aluena_popup_visto', true);
      });
    }
  }
  function mostrarCupomPopup() {
    if (!popupBV) return;
    if (!/[?&]customer_posted=true/.test(location.search) || location.hash !== '#ContactFooter') return;
    var campos = $('.popup-bv-campos', popupBV);
    if (campos) campos.outerHTML = '<p class="popup-bv-msg">Seu cupom de 10% OFF na primeira compra é <strong>BEMVINDA10</strong>. Use no checkout 💌</p>';
    /* tira o convite ("Antes de você ir", "Cadastre-se…") — a pessoa já se cadastrou */
    var eb = $('.eyebrow', popupBV); if (eb) eb.textContent = 'Cadastro feito';
    ['h2 + p', '.popup-bv-legal', '.popup-bv-depois'].forEach(function (s) { var x = $(s, popupBV); if (x) x.style.display = 'none'; });
    store.set('aluena_popup_visto', true);
    abrir(popupBV);
    /* limpa o ?customer_posted da barra, para não reabrir ao atualizar/compartilhar */
    if (window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.delete('customer_posted'); u.hash = '';
      history.replaceState({}, '', u);
    }
  }

  function abrirLightbox(src, cap) {
    if (!src) return;
    $('#lbImg').src = src; $('#lbImg').alt = cap || '';
    $('#lbCap').textContent = cap || '';
    ultimoFoco = document.activeElement;
    lightbox.classList.add('aberto'); document.body.classList.add('sem-scroll');
    painelAtivo = lightbox;
    var f = lightbox.querySelector('[data-fechar]'); if (f) f.focus();
  }

  /* ══════════════════════════════════════════════════════════════════
     Busca (filtra os cards da página)
     ══════════════════════════════════════════════════════════════════ */
  function catalogoDaPagina() {
    var vistos = {}, lista = [];
    $$('.card').forEach(function (card) {
      var p = fromCard(card); if (!p || !p.nome) return;
      if (vistos[p.id]) return; vistos[p.id] = 1;
      p.el = card; lista.push(p);
    });
    var pdp = fromPDP(); if (pdp && !vistos[pdp.id]) { pdp.el = $('.pdp'); vistos[pdp.id] = 1; lista.push(pdp); }
    var dest = fromContainer('.destaque'); if (dest && dest.nome && !vistos[dest.id]) { dest.el = $('.destaque'); vistos[dest.id] = 1; lista.push(dest); }
    return lista;
  }
  /* sinônimos de categoria: "Colares" acha gargantilha/choker etc.; "Novidades" filtra badge Novo */
  var SINONIMOS = {
    colar: ['colar', 'gargantilha', 'choker', 'corrente'], colares: ['colar', 'gargantilha', 'choker', 'corrente'],
    brinco: ['brinco', 'argola'], brincos: ['brinco', 'argola'],
    pulseira: ['pulseira', 'bracelete'], pulseiras: ['pulseira', 'bracelete'],
    anel: ['anel', 'solitario'], aneis: ['anel', 'solitario'],
    conjunto: ['conjunto'], conjuntos: ['conjunto'],
    novidade: ['__novo__'], novidades: ['__novo__']
  };
  function combina(p, q) {
    var termos = String(q || '').trim().split(/\s+/).map(slug).filter(Boolean);
    if (!termos.length) return true;
    var alvo = slug(p.nome + ' ' + p.acab);
    return termos.every(function (t) {
      var toks = SINONIMOS[t] || [t];
      return toks.some(function (tok) { return tok === '__novo__' ? !!p.novo : alvo.indexOf(tok) > -1; });
    });
  }
  /* A busca só enxergava os cards da PÁGINA ATUAL (na página de produto, por exemplo,
     quase nada) — quem buscava "pulseira" ou "zircônias" fora da home ouvia "Nada
     encontrado" mesmo com o produto na loja. Agora, além dos cards da página, consulta a
     busca preditiva da própria Shopify (/search/suggest.json) e junta os resultados; Enter
     leva à página de resultados completa (/search). */
  var buscaTimer, buscaReq = 0;
  function nadaEncontrado(q) {
    return '<div class="busca-nada">Nada encontrado para “' + esc(q) + '”. Tente outra palavra — colar, brinco, pulseira, ouro branco…</div>';
  }
  function buscaRemota(q) {
    if (!SHOPIFY) return;
    clearTimeout(buscaTimer);
    var req = ++buscaReq;
    buscaTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var res = $('#buscaRes');
          if (req !== buscaReq || !res) return;                 // chegou fora de ordem: a digitação seguiu
          var prods = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          var locais = res._itens || [];
          var vistos = {}; locais.forEach(function (p) { vistos[slug(p.nome)] = 1; });
          var extras = prods.filter(function (p) { return !vistos[slug(p.title)]; }).map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
            return { id: 'r' + p.id, nome: p.title, acab: '', preco: parseFloat(p.price) || 0, img: img, url: p.url };
          });
          if (!locais.length && !extras.length) { res.innerHTML = nadaEncontrado(q); return; }
          if (extras.length) desenhaBusca(locais.concat(extras), q);
        })
        .catch(function () {
          var res = $('#buscaRes');
          if (req === buscaReq && res && !(res._itens || []).length) res.innerHTML = nadaEncontrado(q);
        });
    }, 250);
  }
  function renderBusca(q) {
    var res = $('#buscaRes'); if (!res) return;
    var cat = catalogoDaPagina();
    var termo = slug(q);                       // termo normalizado (só símbolos → vazio)
    var itens = cat.filter(function (p) { return combina(p, q); });
    res._itens = itens;
    if (termo && !itens.length) {
      if (SHOPIFY && termo.length >= 2) { res.innerHTML = '<div class="busca-nada">Buscando…</div>'; buscaRemota(q); }
      else res.innerHTML = nadaEncontrado(q);
      return;
    }
    desenhaBusca(itens, q);
    if (SHOPIFY && termo.length >= 2) buscaRemota(q);
  }
  function desenhaBusca(itens, q) {
    var res = $('#buscaRes'); if (!res) return;
    var termo = slug(q);
    res.innerHTML = '<div class="dica">' + (termo ? itens.length + ' resultado' + (itens.length === 1 ? '' : 's') : 'Sugestões') + '</div>'
      + '<div class="busca-grid">' + itens.map(function (p, idx) {
        return '<button class="busca-item" data-idx="' + idx + '">'
          + '<div class="bi-foto">' + (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '') + '</div>'
          + '<div class="bi-nome">' + esc(p.nome) + '</div>'
          + '<div class="bi-preco">' + (p.preco ? BRL(p.preco) : '') + '</div>'
          + '</button>';
      }).join('') + '</div>';
    res._itens = itens;
  }
  function irParaResultado(idx) {
    var res = $('#buscaRes'); if (!res || !res._itens) return;
    var p = res._itens[idx]; if (!p) return;
    if (p.url) { window.location.href = p.url; return; }       // resultado vindo da busca da loja
    fecharTudo();
    if (p.el && p.el.scrollIntoView) {
      setTimeout(function () {
        p.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        p.el.style.transition = 'box-shadow .3s ease';
        p.el.style.boxShadow = '0 0 0 3px var(--salvia-veu),0 0 0 1px var(--salvia)';
        setTimeout(function () { p.el.style.boxShadow = ''; }, 1600);
      }, 320);
    } else { toast('Produto: ' + p.nome); }
  }

  /* ══════════════════════════════════════════════════════════════════
     Toast
     ══════════════════════════════════════════════════════════════════ */
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('mostrar');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('mostrar'); }, 2600);
  }

  /* ══════════════════════════════════════════════════════════════════
     Eventos (delegação global)
     ══════════════════════════════════════════════════════════════════ */
  function bind() {
    /* header por aria-label */
    // $$ e não $: o mesmo rótulo aparece duas vezes no celular — o ícone do
    // cabeçalho e a entrada dentro do menu. Ligar só o primeiro deixaria a
    // entrada do menu morta.
    $$('[aria-label^="Sacola"]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); abrirSacola(); });
    });
    $$('[aria-label="Favoritos"]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); abrirFavoritos(); });
    });
    /* order bump: classe de marcado pra navegador sem :has(); e o link
       "ver medidas" abre o acordeão da ficha em vez de só rolar até ele */
    var bump = $('#bumpCheck');
    if (bump) bump.addEventListener('change', function () { bump.closest('.bump').classList.toggle('marcado', bump.checked); });
    $$('a[href="#ficha"]').forEach(function (a) {
      a.addEventListener('click', function () { var d = $('#ficha'); if (d && d.tagName === 'DETAILS') d.open = true; });
    });
    $$('[aria-label="Buscar"]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); abrirBusca(); });
    });

    document.addEventListener('click', function (e) {
      var t = e.target;

      /* menu mobile: toque fora do menu (e fora do hambúrguer) fecha */
      var navEl = $('#nav');
      if (navEl && navEl.classList.contains('aberto') && !t.closest('#nav') && !t.closest('.hamburger')) fecharNav();

      /* fechar painéis */
      if (t.closest('[data-fechar]')) { e.preventDefault(); fecharTudo(); return; }
      /* clique no fundo escuro do lightbox fecha */
      if (t.id === 'lightbox') { fecharTudo(); return; }

      /* categorias / links de navegação → abrem a busca já filtrada */
      var buscaEl = t.closest('[data-busca]');
      if (buscaEl) { e.preventDefault(); fecharNav(); abrirBusca(buscaEl.getAttribute('data-busca')); return; }

      /* coração de card */
      var fav = t.closest('.card-fav');
      if (fav) {
        e.preventDefault();
        var card = fav.closest('.card');
        var ok = toggleWish(fromCard(card));
        toast(ok ? 'Salvo nos favoritos ♥' : 'Removido dos favoritos');
        return;
      }

      /* botão "Adicionar" dentro de card */
      var cbtn = t.closest('.card-btn');
      if (cbtn) {
        e.preventDefault();
        var card = cbtn.closest('.card');
        /* "Completar conjunto" (card do "Complete o look" na PDP): foco em
           conversão — um clique só leva a peça atual E a parceira pra
           sacola juntas, sem o cliente ter que voltar pra página da outra
           peça. O desconto do par (configurado como desconto automático na
           Shopify — ver diário) entra sozinho por já estarem as duas no
           carrinho, sem precisar de nenhum código aqui. */
        if (cbtn.closest('.galeria-conjunto')) {
          var pdp = fromPDP();
          var parceiro = fromCard(card);
          if (SHOPIFY && pdp && pdp.variantId && parceiro && parceiro.variantId) {
            addCartShopifyItens([{ id: pdp.variantId, quantity: 1 }, { id: parceiro.variantId, quantity: 1 }])
              .then(function () { toast('As duas peças foram pra sacola, com desconto ✓'); abrirSacola(); });
          } else {
            addCart(pdp, 1).then(function () { return addCart(parceiro, 1); })
              .then(function () { toast('As duas peças foram pra sacola ✓'); abrirSacola(); });
          }
          return;
        }
        addCart(fromCard(card), 1).then(function () { toast('Adicionado à sacola ✓'); abrirSacola(); });
        return;
      }

      /* ações por data-acao */
      var acaoEl = t.closest('[data-acao]');
      if (acaoEl) {
        var acao = acaoEl.getAttribute('data-acao');
        if (acao === 'add-pdp' || acao === 'buy-pdp') {
          e.preventDefault();
          var qi = $('#qtd');
          var q = Math.max(1, Math.min(10, parseInt((qi || {}).value, 10) || 1));
          if (qi) qi.value = q;                    // sincroniza o campo com o valor efetivo
          /* order bump marcado ("leve junto") entra na mesma leva */
          var bumpEl = $('#bumpCheck');
          var bumpWrap = bumpEl ? bumpEl.closest('[data-combo-variant-id]') : null;
          var bumpVar = bumpEl && bumpEl.checked && bumpWrap ? bumpWrap.getAttribute('data-combo-variant-id') : '';
          var pdp = fromPDP();
          var leva;
          if (bumpVar && SHOPIFY && pdp && pdp.variantId) {
            leva = addCartShopifyItens([{ id: pdp.variantId, quantity: q }, { id: bumpVar, quantity: 1 }]);
          } else {
            leva = addCart(pdp, q).then(function () {
              return bumpVar ? addCart({ id: 'v' + bumpVar, variantId: bumpVar }, 1) : null;
            });
          }
          leva.then(function () {
            if (acao === 'buy-pdp') {
              /* vai para a sacola, não direto ao checkout: o desconto de 5% no Pix só
                 existe pelo botão "Pagar no Pix" (app Scala), que fica na sacola — pelo
                 checkout direto o Pix sairia sem o desconto que a página anuncia */
              if (SHOPIFY) { window.location.href = '/cart'; return; }
              toast('Redirecionando para o checkout…');
            } else { toast(bumpVar ? 'As duas peças foram para a sacola ✓' : 'Adicionado à sacola ✓'); }
            abrirSacola();
          });
          return;
        }
        if (acao === 'completar-conjunto') {
          e.preventDefault();
          var cj = acaoEl.closest('.galeria-conjunto');
          var pdpC = fromPDP();
          var itensC = [];
          if (pdpC && pdpC.variantId) itensC.push({ id: pdpC.variantId, quantity: 1 });
          $$('.conjunto-peca[data-variant-id]', cj).forEach(function (a) {
            itensC.push({ id: a.getAttribute('data-variant-id'), quantity: 1 });
          });
          if (SHOPIFY && itensC.length > 1) {
            /* uma chamada só pro carrinho: o desconto automático do conjunto só vale com todas as
               peças presentes, e duas chamadas em paralelo disputariam o mesmo carrinho */
            addCartShopifyItens(itensC).then(function () {
              toast('As ' + itensC.length + ' peças foram pra sacola, com desconto ✓'); abrirSacola();
            });
          }
          return;
        }
        if (acao === 'add-combo') {
          e.preventDefault();
          var pdp = fromPDP();
          if (SHOPIFY) {
            var comboEl = $('[data-combo-variant-id]');
            var comboVariant = comboEl ? comboEl.getAttribute('data-combo-variant-id') : '';
            var passos = [addCart(pdp, 1)];
            if (comboVariant) passos.push(addCart({ id: 'v' + comboVariant, variantId: comboVariant }, 1));
            Promise.all(passos).then(function () { toast('Combo adicionado à sacola ✓'); abrirSacola(); });
          } else {
            // combo = item único com 10% OFF já aplicado (protótipo)
            addCart({ id: 'combo-ponto-de-luz', nome: 'Combo Ponto de Luz — Brinco + Gargantilha', acab: 'Banhado a ouro 18k · 10% OFF', preco: 123.53, img: pdp ? pdp.img : '' }, 1)
              .then(function () { toast('Combo adicionado à sacola ✓'); abrirSacola(); });
          }
          return;
        }
        if (acao === 'add-complemento') {
          e.preventDefault();
          var li = acaoEl.closest('.complemento');
          if (!li) return;
          var vid = li.getAttribute('data-variant-id');
          var imgC = $('.complemento-foto img', li);
          addCart({
            id: vid ? 'v' + vid : slug(txt('.complemento-nome', li)),
            variantId: vid,
            nome: txt('.complemento-nome', li),
            acab: txt('.complemento-tipo', li),
            preco: parseBRL(txt('.complemento-preco', li)),
            img: imgC ? imgC.getAttribute('src') : ''
          }, 1).then(function () {
            /* confirma na própria linha: o cliente não perde o lugar na página */
            var rot = acaoEl.querySelector('span');
            var antes = rot ? rot.textContent : '';
            acaoEl.classList.add('feito');
            if (rot) rot.textContent = 'Na sacola';
            toast('Adicionado à sacola ✓');
            setTimeout(function () {
              acaoEl.classList.remove('feito');
              if (rot) rot.textContent = antes;
            }, 2200);
          });
          return;
        }
        if (acao === 'fav-pdp') {
          e.preventDefault();
          var ok2 = toggleWish(fromPDP());
          toast(ok2 ? 'Salvo nos favoritos ♥' : 'Removido dos favoritos');
          return;
        }
        if (acao === 'add-destaque' || acao === 'buy-destaque') {
          e.preventDefault();
          addCart(fromContainer('.destaque'), 1).then(function () {
            if (acao === 'buy-destaque') {
              if (SHOPIFY) { window.location.href = '/cart'; return; } // sacola: é lá que fica o botão do Pix com 5% (ver buy-pdp)
              toast('Redirecionando para o checkout…');
            } else { toast('Adicionado à sacola ✓'); }
            abrirSacola();
          });
          return;
        }
      }

      /* sacola: stepper / remover / checkout */
      var li = t.closest('.linha-item');
      if (li && li.closest('#cartItens')) {
        var id = li.getAttribute('data-id');
        var atual = 0; for (var k = 0; k < cart.length; k++) if (cart[k].id === id) { atual = cart[k].qty; break; }
        if (t.closest('[data-mais]')) { setQty(id, Math.min(10, atual + 1)); return; }
        if (t.closest('[data-menos]')) { setQty(id, Math.max(1, atual - 1)); return; } // piso 1; remover é só no botão Remover
        if (t.closest('[data-remover]')) { removeCart(id); toast('Item removido'); return; }
      }
      if (t.closest('[data-checkout]')) {
        e.preventDefault();
        if (SHOPIFY) { window.location.href = '/checkout'; return; }
        toast('Indo para o checkout seguro… (protótipo)');
        return;
      }

      /* favoritos: mover / remover */
      var lw = t.closest('.linha-item');
      if (lw && lw.closest('#wishItens')) {
        var wid = lw.getAttribute('data-id'); var it = wish[wid];
        if (t.closest('[data-mover]') && it) {
          addCart(it, 1).then(function () {
            delete wish[wid]; salvar(); renderWish(); updateBadges(); syncHearts();
            toast('Movido para a sacola ✓'); abrirSacola();
          });
          return;
        }
        if (t.closest('[data-desfav]')) { delete wish[wid]; salvar(); renderWish(); updateBadges(); syncHearts(); return; }
      }

      /* resultado de busca */
      var bi = t.closest('.busca-item');
      if (bi) { e.preventDefault(); irParaResultado(parseInt(bi.getAttribute('data-idx'), 10)); return; }

      /* lightbox (zoom da PDP) — só para foto: no vídeo o clique é do player */
      if (t.closest('.palco-zoom') || (t.tagName === 'IMG' && t.classList.contains('palco-midia'))) {
        var im = $('#palco .palco-midia:not([hidden])');
        if (!im || im.tagName !== 'IMG') return;
        e.preventDefault();
        abrirLightbox(im.src, im.alt);
        return;
      }

      /* placeholders de navegação (#) — evita salto ao topo */
      var a = t.closest('a[href="#"]');
      if (a) { e.preventDefault(); }
    });

    /* busca ao digitar */
    document.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'buscaInput') renderBusca(e.target.value);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.id === 'buscaInput' && SHOPIFY) {
        var q = e.target.value.trim();
        if (q) { e.preventDefault(); window.location.href = '/search?q=' + encodeURIComponent(q); }
      }
    });

    /* clamp do campo de quantidade da PDP ao sair/alterar (1..10) */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'qtd') {
        e.target.value = Math.max(1, Math.min(10, parseInt(e.target.value, 10) || 1));
      }
    });

    /* teclado: ESC fecha; Tab fica preso dentro do painel aberto (focus trap) */
    document.addEventListener('keydown', function (e) {
      if (!painelAtivo) return;
      if (e.key === 'Escape') { fecharTudo(); return; }
      if (e.key === 'Tab') {
        var foc = focaveis(painelAtivo);
        if (!foc.length) return;
        var pri = foc[0], ult = foc[foc.length - 1];
        if (e.shiftKey && document.activeElement === pri) { e.preventDefault(); ult.focus(); }
        else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
        else if (foc.indexOf(document.activeElement) === -1) { e.preventDefault(); pri.focus(); }
      }
    });

    /* backdrop já tem data-fechar (tratado no click) */
    if (backdrop) backdrop.addEventListener('click', function () { fecharTudo(); });
  }

  function focaveis(cont) {
    return $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', cont)
      .filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
  }
  function fecharNav() {
    var nav = $('#nav'), ham = $('.hamburger');
    if (nav) nav.classList.remove('aberto');
    if (ham) { ham.setAttribute('aria-expanded', 'false'); ham.setAttribute('aria-label', 'Abrir menu'); }
  }

  /* ══════════════════════════════════════════════════════════════════
     Helpers globais usados por onclick inline nas páginas
     ══════════════════════════════════════════════════════════════════ */
  window.mostrarToast = toast;
  /*
    Galeria da PDP: todas as mídias já estão no palco empilhadas e escondidas,
    a troca só alterna qual fica visível. Vídeo entra com preload="none", então
    dar play aqui é o que efetivamente começa a baixar — e sair da mídia pausa,
    senão o áudio de um vídeo continua rodando sob a foto seguinte.
  */
  /*
    Uma mídia escondida com [hidden] nunca entra no viewport, então
    loading="lazy" só dispara o download no clique — era isso que fazia a
    troca de foto "piscar" esperando. A cada troca a gente promove as
    vizinhas a eager, e o navegador já as tem prontas no próximo passo.
  */
  function prepararVizinhas(midias, idx) {
    [idx - 1, idx + 1].forEach(function (i) {
      var m = midias[i];
      if (!m || m.tagName !== 'IMG') return;
      if (m.getAttribute('loading') === 'lazy') m.setAttribute('loading', 'eager');
    });
  }

  /*
    Peça com variação de cor (ex.: Azul Claro / Rosa da mesma joia): cada foto
    carrega a cor a que pertence em data-cor (o Liquid descobre isso pelo alt
    da imagem). Sem cor ativa no palco — ou seja, todo produto sem eixo "Cor" —
    tudo se comporta exatamente como antes, sem filtro nenhum.
  */
  function corDaMidia(el) { return el.getAttribute('data-cor') || ''; }
  function corAtivaDoPalco(palco) { return palco.getAttribute('data-cor-ativa') || ''; }
  function midiaPertenceACor(el, cor) {
    if (!cor) return true;
    var c = corDaMidia(el);
    return !c || c === cor;
  }
  function indicesVisiveis(midias, cor) {
    var out = [];
    midias.forEach(function (m, i) { if (midiaPertenceACor(m, cor)) out.push(i); });
    return out.length ? out : midias.map(function (m, i) { return i; });
  }

  function irParaMidia(idx) {
    var palco = $('#palco'); if (!palco) return;
    var midias = $$('.palco-midia', palco);
    if (!midias.length) return;
    var cor = corAtivaDoPalco(palco);
    var visiveis = indicesVisiveis(midias, cor);
    if (idx < 0) idx = visiveis[0];
    if (visiveis.indexOf(idx) === -1) idx = visiveis[0];

    midias.forEach(function (m, i) {
      var pertence = midiaPertenceACor(m, cor);
      var ativo = i === idx;
      m.hidden = !ativo || !pertence;
      if (m.tagName === 'VIDEO') {
        if (ativo && pertence) { var p = m.play(); if (p && p.catch) p.catch(function () {}); }
        else { m.pause(); }
      }
    });
    prepararVizinhas(midias, idx);
    palco.setAttribute('data-atual', String(idx));

    var contador = $('#palcoContador');
    if (contador) contador.textContent = (visiveis.indexOf(idx) + 1) + ' / ' + visiveis.length;

    var thumbs = $$('.thumb');
    thumbs.forEach(function (x, i) {
      x.hidden = !midiaPertenceACor(x, cor);
      x.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
    var ativa = thumbs[idx];
    if (ativa && !ativa.hidden && ativa.scrollIntoView) {
      ativa.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    $$('.palco-pontos .pp', palco).forEach(function (p, i) {
      p.hidden = !midiaPertenceACor(p, cor);
      p.classList.toggle('on', i === idx);
    });
    var dica = $('.palco-dica', palco);
    if (dica && visiveis.indexOf(idx) > 0) dica.classList.add('sumiu');
    return idx;
  }

  /*
    Troca de cor no seletor de variante: pula pro primeiro slide daquela cor
    (ou pra Foto 1 se a peça não tiver fotos marcadas por cor nenhuma).
  */
  function irParaCor(cor) {
    var palco = $('#palco'); if (!palco) return;
    palco.setAttribute('data-cor-ativa', cor || '');
    var midias = $$('.palco-midia', palco);
    var visiveis = indicesVisiveis(midias, cor || '');
    irParaMidia(visiveis[0]);
  }
  window.__aluenaIrParaCor = irParaCor;

  /* passo (+1/-1) dentro só das mídias da cor ativa, sem voltar ao início */
  function passoNaCor(palco, atual, direcao) {
    var midias = $$('.palco-midia', palco);
    var cor = corAtivaDoPalco(palco);
    var visiveis = indicesVisiveis(midias, cor);
    var pos = visiveis.indexOf(atual);
    if (pos === -1) return null;
    var proxPos = pos + direcao;
    if (proxPos < 0 || proxPos > visiveis.length - 1) return null;
    return visiveis[proxPos];
  }

  window.mostrarMidia = function (botao, idx) { irParaMidia(idx); };

  /*
    Os CTAs espalhados pelas seções editoriais sobem de volta para o painel
    de compra em vez de apontarem para uma âncora fixa: no mobile o painel
    fica logo abaixo da galeria, no desktop fica ao lado dela.
  */
  function ligarCtasCompra() {
    var painel = $('.compra-acoes') || $('.compra');
    if (!painel) return;
    $$('[data-acao="ir-comprar"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        painel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var alvo = $('#qtd') || painel.querySelector('button');
        if (alvo && alvo.focus) setTimeout(function () { alvo.focus({ preventScroll: true }); }, 420);
      });
    });
  }

  /*
    Arrastar para o lado é como se troca foto no celular. Só conta como
    swipe o gesto claramente horizontal, senão a gente sequestraria a
    rolagem vertical da página.
  */
  function iniciarSwipeGaleria() {
    var palco = $('#palco'); if (!palco) return;
    var total = $$('.palco-midia', palco).length;
    if (total < 2) return;

    var x0 = 0, y0 = 0, arrastando = false;

    palco.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      arrastando = true;
    }, { passive: true });

    palco.addEventListener('touchend', function (e) {
      if (!arrastando) return;
      arrastando = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      var atual = parseInt(palco.getAttribute('data-atual') || '0', 10);
      var proximo = passoNaCor(palco, atual, dx < 0 ? 1 : -1);
      if (proximo == null) return;
      irParaMidia(proximo);
    }, { passive: true });

    // setas do teclado quando a galeria está em foco, de graça para o desktop
    palco.addEventListener('keydown', function (e) {
      var atual = parseInt(palco.getAttribute('data-atual') || '0', 10);
      if (e.key === 'ArrowRight') { e.preventDefault(); var p = passoNaCor(palco, atual, 1); if (p != null) irParaMidia(p); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); var q = passoNaCor(palco, atual, -1); if (q != null) irParaMidia(q); }
    });

    palco.setAttribute('data-atual', '0');
    palco.setAttribute('tabindex', '0');
    prepararVizinhas($$('.palco-midia', palco), 0);
  }
  window.passoQtd = function (d) {
    var i = $('#qtd'); if (!i) return;
    i.value = Math.max(1, Math.min(10, (parseInt(i.value, 10) || 1) + d));
  };
  /* Calculadora de frete da PDP: a tabela vem de snippets/frete-tabela.liquid,
     gerado por scripts/shopify-frete.mjs com os MESMOS valores do checkout. */
  var FAIXAS_CEP = [ // [início, fim, UF] pelos 5 primeiros dígitos
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
    [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];
  function ufDoCep(cep) {
    var n = parseInt(cep.slice(0, 5), 10);
    for (var i = 0; i < FAIXAS_CEP.length; i++) if (n >= FAIXAS_CEP[i][0] && n <= FAIXAS_CEP[i][1]) return FAIXAS_CEP[i][2];
    return null;
  }
  function tabelaFrete() {
    var el = $('#freteTabela'); if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function renderFrete(r, t, uf, cidade, subtotal) {
    var f = t.uf[uf];
    var gratis = subtotal >= t.gratis;
    var prazo = function (p) { return p[0] + ' a ' + p[1] + ' dias úteis'; };
    var linha = function (nome, p, valor, destaque) {
      return '<div class="frete-opcao"><span class="nome"><b>' + nome + '</b> <span class="prazo">· ' + prazo(p) +
        '</span></span><span class="valor">' + (destaque ? '<b>' + valor + '</b>' : valor) + '</span></div>';
    };
    var falta = t.gratis - subtotal;
    r.innerHTML =
      '<p class="frete-destino">Entrega para <b>' + (cidade || uf) + '</b></p>' +
      linha('PAC', f.pacPrazo, gratis ? 'Grátis' : BRL(f.pac), gratis) +
      linha('SEDEX', f.sedexPrazo, BRL(f.sedex)) +
      '<p class="frete-obs">' + (gratis ? 'Frete grátis no PAC, porque a compra passa de ' + BRL(t.gratis) + '.'
        : 'Faltam ' + BRL(falta) + ' para o <b>frete grátis</b> (compras acima de ' + BRL(t.gratis) + ').') +
      ' Prazo contado a partir da confirmação do pagamento.</p>';
    r.classList.add('mostrar');
  }
  window.calcularFrete = function () {
    var cepEl = $('#cep'), r = $('#freteResultado'); if (!cepEl || !r) return;
    var cep = cepEl.value.replace(/\D/g, '');
    if (cep.length < 8) { toast('Digite um CEP válido (8 dígitos)'); return; }
    var t = tabelaFrete(); if (!t) return;
    var pdp = fromPDP();
    var qtd = parseInt(($('#qtd') || {}).value, 10) || 1;
    var subtotal = (pdp && pdp.preco ? pdp.preco : (parseInt(r.getAttribute('data-preco'), 10) || 0) / 100) * qtd;
    var porFaixa = ufDoCep(cep);
    // ViaCEP confirma o CEP e dá o nome da cidade; se falhar, a faixa numérica resolve o estado
    var ctrl = window.AbortController ? new AbortController() : null;
    var tempo = setTimeout(function () { if (ctrl) ctrl.abort(); }, 3500);
    fetch('https://viacep.com.br/ws/' + cep + '/json/', ctrl ? { signal: ctrl.signal } : {})
      .then(function (res) { return res.json(); })
      .then(function (d) {
        clearTimeout(tempo);
        // ViaCEP não conhece todo CEP válido (ex.: 95000-000); aí vale a faixa numérica, como no checkout
        if (d && d.erro && !porFaixa) { toast('CEP não encontrado. Confira os números.'); r.classList.remove('mostrar'); return; }
        var uf = (d && !d.erro && d.uf) || porFaixa;
        if (!uf || !t.uf[uf]) { toast('Não encontramos esse CEP.'); return; }
        renderFrete(r, t, uf, d && !d.erro && d.localidade ? d.localidade + '/' + uf : null, subtotal);
      })
      .catch(function () {
        clearTimeout(tempo);
        if (!porFaixa || !t.uf[porFaixa]) { toast('Não encontramos esse CEP.'); return; }
        renderFrete(r, t, porFaixa, null, subtotal);
      });
  };
  window.toggleNav = function (btn) {
    var nav = $('#nav'); if (!nav) return;
    var aberto = nav.classList.toggle('aberto');
    btn.setAttribute('aria-expanded', aberto ? 'true' : 'false');
    btn.setAttribute('aria-label', aberto ? 'Fechar menu' : 'Abrir menu');
  };

  /* ══════════════════════════════════════════════════════════════════
     Genéricos (header shadow, reveal, máscara CEP)
     ══════════════════════════════════════════════════════════════════ */
  function genericos() {
    var header = $('#header');
    if (header) addEventListener('scroll', function () { header.classList.toggle('rolou', scrollY > 8); }, { passive: true });

    var cepEl = $('#cep');
    if (cepEl) {
      cepEl.addEventListener('input', function (e) {
        var v = e.target.value.replace(/\D/g, '').slice(0, 8);
        e.target.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
      });
      cepEl.addEventListener('keydown', function (e) {   // Enter no CEP calcula
        if (e.key === 'Enter') { e.preventDefault(); window.calcularFrete(); }
      });
    }

    /* barra de compra fixa no mobile (PDP): aparece após passar do painel */
    var barra = $('#barraFixa'), painelCompra = $('.compra-acoes');
    if (barra && painelCompra && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        var e0 = ents[0];
        barra.classList.toggle('mostrar', !e0.isIntersecting && e0.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(painelCompra);
    }

    var alvos = $$('.reveal');
    if (!alvos.length) alvos = $$('.secao-header,.card,.cat-item,.selo,.duo-card,.destaque-foto,.destaque-info,.sobre-foto,.sobre-texto,.news-in');
    var semMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!semMotion && 'IntersectionObserver' in window) {
      var grupos = new Map();
      alvos.forEach(function (elm) {
        elm.classList.add('reveal');
        var pai = elm.parentElement;
        var i = grupos.get(pai) || 0;
        elm.style.setProperty('--d', Math.min(i * 0.07, 0.42) + 's');
        grupos.set(pai, i + 1);
      });
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('visivel'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      alvos.forEach(function (elm) { io.observe(elm); });
    } else { alvos.forEach(function (elm) { elm.classList.add('visivel'); }); }
  }

  /* ══════════════════════════════════════════════════════════════════
     PDP — escolha de variante (cor / tamanho)
     Ao trocar um chip, acha a variante correspondente, atualiza preço,
     disponibilidade, o id que vai para a sacola e a URL (?variant=).
     Chips cuja combinação não existe ficam desabilitados.
     ══════════════════════════════════════════════════════════════════ */
  function variantesInit() {
    var caixa = $('[data-opcoes]'); if (!caixa) return;
    var painel = $('.compra'); if (!painel) return;

    var dados;
    try { dados = JSON.parse($('[data-variantes]', caixa).textContent); }
    catch (e) { return; }
    if (!dados || !dados.length) return;

    var chips = $$('input[data-opcao-index]', caixa);
    var corEixo = parseInt(caixa.getAttribute('data-cor-eixo'), 10);
    if (isNaN(corEixo)) corEixo = -1;

    function selecionadas() {
      var v = [];
      chips.forEach(function (c) {
        if (c.checked) v[parseInt(c.getAttribute('data-opcao-index'), 10)] = c.value;
      });
      return v;
    }
    function acha(vals) {
      for (var i = 0; i < dados.length; i++) {
        var ok = true;
        for (var k = 0; k < vals.length; k++) {
          if (vals[k] !== undefined && dados[i].opcoes[k] !== vals[k]) { ok = false; break; }
        }
        if (ok) return dados[i];
      }
      return null;
    }
    /* Só desabilita o valor que não existe disponível em NENHUMA combinação.
       Bloquear "Colorido" porque o tamanho 30 escolhido está esgotado deixaria
       o cliente sem alcançar o Colorido 35, que tem estoque. */
    function marcarIndisponiveis() {
      chips.forEach(function (c) {
        var idx = parseInt(c.getAttribute('data-opcao-index'), 10);
        c.disabled = !dados.some(function (v) { return v.disp && v.opcoes[idx] === c.value; });
      });
    }

    /* Resolve a variante respeitando o eixo que o cliente acabou de tocar:
       se a combinação exata estiver esgotada, move os OUTROS eixos para a
       primeira combinação disponível — em vez de travar a escolha. */
    function resolver(vals, eixoTocado) {
      var exata = acha(vals);
      if (exata && exata.disp) return exata;
      for (var i = 0; i < dados.length; i++) {
        if (!dados[i].disp) continue;
        if (eixoTocado != null && dados[i].opcoes[eixoTocado] !== vals[eixoTocado]) continue;
        return dados[i];
      }
      return exata;
    }

    /* deixa os chips marcados iguais à variante realmente aplicada */
    function sincronizarChips(v) {
      chips.forEach(function (c) {
        var idx = parseInt(c.getAttribute('data-opcao-index'), 10);
        c.checked = v.opcoes[idx] === c.value;
      });
    }

    /* Mesmo aviso de estoque que o Liquid renderiza no carregamento da
       página (esgotado / restam N unidades / em estoque), mas recalculado
       a cada troca de variante — sem isso o aviso ficava travado no
       estoque da variante com que a página abriu, ainda que a pessoa
       tivesse trocado pra uma cor com estoque diferente. */
    function atualizarEstoqueAviso(v) {
      var el = $('#estoqueAviso'); if (!el) return;
      var svgEsgotado = '<svg viewBox="0 0 24 24"><path d="M13 2 3 14h7l-1 8 10-12h-7z"/></svg>';
      var svgOk = '<svg viewBox="0 0 24 24"><path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>';
      if (!v.disp) {
        el.className = 'estoque-aviso';
        el.innerHTML = svgEsgotado + ' Produto esgotado no momento';
      } else if (v.gerenciada && v.estoque > 0 && v.estoque <= 10) {
        el.className = 'estoque-aviso';
        el.innerHTML = svgEsgotado + ' Só ' + (v.estoque === 1 ? 'resta 1 unidade' : 'restam ' + v.estoque + ' unidades');
      } else {
        el.className = 'estoque-aviso ok';
        el.innerHTML = svgOk + ' Em estoque, pronta para envio';
      }
    }

    /* Card "Complete o conjunto" (ver aluena-product.liquid, seção #combine
       logo após o painel de compra): quando a peça do conjunto tem a MESMA
       opção "Cor", o card troca foto/link/preço pra variante daquela cor
       junto com a escolha aqui — sem isso o card sempre mostrava a cor
       padrão (a primeira) do produto, mesmo com o cliente vendo Rosa. */
    function atualizarCardsConjunto(cor) {
      $$('.combine-item[data-combine-cor-eixo]').forEach(function (item) {
        var script = $('.combine-cores-dados', item);
        var card = $('.card', item);
        if (!script || !card) return;
        var dados; try { dados = JSON.parse(script.textContent); } catch (e) { return; }
        var d = dados[cor]; if (!d) return;
        card.setAttribute('data-variant-id', d.variantId);
        var img = $('.card-foto img', card);
        if (img) { img.removeAttribute('srcset'); img.src = d.imagem; }
        $$('.card-foto a, .card-nome a', card).forEach(function (a) { a.href = d.url; });
        var preco = $('.card-preco', card); if (preco) preco.textContent = d.preco;
        var parcela = $('.card-parcela', card); if (parcela) parcela.textContent = '3× de ' + d.parcela;
      });
    }

    /* Order bump ("leve junto") com o mesmo eixo "Cor": troca variante e
       foto junto com o chip, pelo JSON que a PDP imprime dentro do label. */
    function atualizarBump(cor) {
      var wrap = $('.bump[data-bump-cor]'); if (!wrap) return;
      var script = $('.bump-cores-dados', wrap); if (!script) return;
      var dados; try { dados = JSON.parse(script.textContent); } catch (e) { return; }
      var d = dados[cor]; if (!d) return;
      wrap.setAttribute('data-combo-variant-id', d.variantId);
      var img = $('img', wrap); if (img && d.imagem) img.src = d.imagem;
      var chk = $('#bumpCheck', wrap);
      if (chk) { chk.disabled = !d.disp; if (!d.disp) chk.checked = false; wrap.classList.toggle('bump--indisp', !d.disp); }
    }

    function aplicar(v) {
      if (!v) return;
      sincronizarChips(v);
      painel.setAttribute('data-variant-id', v.id);
      atualizarEstoqueAviso(v);

      /* peça com eixo "Cor": ao trocar de cor, a galeria pula pras fotos
         daquela cor. Some quando o eixo tocado foi outro (ex.: Tamanho)
         e a cor continua a mesma — assim não perde a foto que a pessoa
         estava vendo por causa de uma troca em outro eixo. */
      if (corEixo >= 0 && typeof window.__aluenaIrParaCor === 'function') {
        var corNova = v.opcoes[corEixo];
        var palcoEl = $('#palco');
        var corAtual = palcoEl ? palcoEl.getAttribute('data-cor-ativa') : null;
        if (corNova && corNova !== corAtual) window.__aluenaIrParaCor(corNova);
        if (corNova) { atualizarCardsConjunto(corNova); atualizarBump(corNova); }
      }

      var por = $('.preco-por', painel);
      if (por) por.textContent = BRL(v.preco / 100);
      var de = $('.preco-de', painel);
      var off = $('.preco-off', painel);
      if (v.comparar > v.preco) {
        if (de) { de.textContent = BRL(v.comparar / 100); de.style.display = ''; }
        if (off) { off.textContent = '-' + Math.floor((v.comparar - v.preco) * 100 / v.comparar) + '%'; off.style.display = ''; }
      } else {
        if (de) de.style.display = 'none';
        if (off) off.style.display = 'none';
      }
      var parc = $('.preco-parcela b', painel);
      if (parc) parc.textContent = '3× de ' + BRL(v.preco / 3 / 100);
      var pix = $('.chip-pix', painel);
      if (pix) {
        var b = pix.querySelector('b');
        pix.childNodes.forEach && Array.prototype.forEach.call(pix.childNodes, function (n) {
          if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' ' + BRL(Math.round(v.preco * (1 - PIX_OFF)) / 100) + ' no Pix ';
        });
        if (b) b.textContent = '(' + PIX_PCT + '% OFF)';
      }

      /* rótulo do valor escolhido ao lado do nome da opção */
      var vals = selecionadas();
      $$('[data-opcao-atual]', caixa).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-opcao-atual'), 10);
        if (vals[i]) el.textContent = vals[i];
      });

      /* botões e barra fixa */
      var comprar = $('[data-acao="buy-pdp"]'), addSac = $('[data-acao="add-pdp"]');
      if (comprar) comprar.textContent = v.disp ? 'Comprar agora' : 'Esgotado';
      if (addSac) {
        var rot = addSac.querySelector('span');
        var txt = v.disp ? 'Adicionar à sacola' : 'Esgotado';
        if (rot) rot.textContent = txt;
        else addSac.lastChild && (addSac.lastChild.textContent = ' ' + txt);
      }
      var bfPreco = $('.barra-fixa .bf-preco');
      if (bfPreco) bfPreco.innerHTML = BRL(v.preco / 100) + ' <small>3× ' + BRL(v.preco / 3 / 100) + '</small>';

      /* mantém a URL compartilhável apontando para a variante escolhida */
      if (window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
      marcarIndisponiveis();
    }

    caixa.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-opcao-index]')) return;
      var eixo = parseInt(e.target.getAttribute('data-opcao-index'), 10);
      aplicar(resolver(selecionadas(), eixo));
    });
    marcarIndisponiveis();
    /* a peça pode abrir numa combinação esgotada; alinha tudo já na carga */
    aplicar(resolver(selecionadas(), null));
  }

  /* ══════════════════════════════════════════════════════════════════
     Página de coleção (PLP) — filtra por tipo/acabamento (chips no
     #filtros) e ordena os cards já renderizados pela Shopify (a
     categoria em si já vem filtrada pela própria coleção/Liquid).
     ══════════════════════════════════════════════════════════════════ */
  function plpInit() {
    var grade = $('#grade'); if (!grade) return;
    var ordem = $$('.card', grade);
    var sel = $('#ordenarSel');
    var filtrosEl = $('#filtros');
    var vazioEl = $('#plpVazio');
    var ativos = {};   // { tipo: ['brinco','colar'], acabamento: ['ouro'] }
    function num(el, a) { return parseFloat(el.getAttribute(a)) || 0; }

    function passaNoFiltro(card) {
      return Object.keys(ativos).every(function (grupo) {
        var vals = ativos[grupo];
        if (!vals.length) return true;
        return vals.indexOf(card.getAttribute('data-' + grupo) || '') > -1;
      });
    }

    function aplicar() {
      var visiveis = ordem.filter(passaNoFiltro);
      ordem.forEach(function (c) { c.classList.toggle('oculto', visiveis.indexOf(c) === -1); });

      var sort = sel ? sel.value : 'rel';
      var ord = visiveis.slice();
      if (sort === 'menor') ord.sort(function (a, b) { return num(a, 'data-preco') - num(b, 'data-preco'); });
      else if (sort === 'maior') ord.sort(function (a, b) { return num(b, 'data-preco') - num(a, 'data-preco'); });
      ord.forEach(function (c) { grade.appendChild(c); });

      setTxt('plpCount', visiveis.length);
      setTxt('plpCountLabel', visiveis.length === 1 ? 'peça' : 'peças');
      if (vazioEl) vazioEl.classList.toggle('mostrar', visiveis.length === 0);
      syncHearts();
    }

    if (sel) sel.addEventListener('change', aplicar);
    if (filtrosEl) {
      filtrosEl.addEventListener('click', function (e) {
        var chip = e.target.closest('.filtro-chip'); if (!chip) return;
        var grupoEl = chip.closest('[data-filtro-grupo]'); if (!grupoEl) return;
        var grupo = grupoEl.getAttribute('data-filtro-grupo');
        chip.classList.toggle('ativo');
        ativos[grupo] = $$('.filtro-chip.ativo', grupoEl).map(function (c) { return c.getAttribute('data-filtro-valor'); });
        aplicar();
      });
    }
    aplicar();
  }
  function setTxt(id, v) { var e = $('#' + id); if (e) e.textContent = v; }

  /* ══════════════════════════════════════════════════════════════════
     Boot
     ══════════════════════════════════════════════════════════════════ */
  function init() {
    montarUI();
    garantirCoracoes();
    bind();
    genericos();
    iniciarSwipeGaleria();
    ligarCtasCompra();
    variantesInit();
    plpInit();
    iniciarPopupBoasVindas();
    mostrarCupomPopup();
    renderWish(); updateBadges(); syncHearts();
    if (SHOPIFY) refreshCartShopify(); else { renderCart(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
